export default class Deployments {
	static async loadDeployment(quizId, onSuccess=()=>{}, onError=()=>{}) {
		try {
			let url;
			const port = process.env.REACT_APP_FORWARD_API_PORT;
			if (process.env.NODE_ENV === 'development') {
				url = `http://127.0.0.1:${port}/forward_api?quizid=${quizId}`;
			} else {
				url = `https://us-west2-quiz-composer-349722.cloudfunctions.net/forward_api?quizid=${quizId}`;
			}
			const response = await fetch(url);
			const json_response = await response.json();
			const deployment = await JSON.parse(json_response);
			const quiz = deployment[quizId];
			onSuccess(quiz);
		} catch (error) {
		  console.error("error when fetching deployment from db: ", error.toString());
		  onError(error)
		}
	}
}